package ru.villawonka.app.presentation.design.components

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.Colors
import androidx.compose.material.Icon
import androidx.compose.material.IconButton
import androidx.compose.material.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.ui.tooling.preview.Preview
import ru.villawonka.app.presentation.design.extensions.AppSpacer
import ru.villawonka.app.presentation.design.theme.AppColors
import ru.villawonka.app.presentation.design.theme.AppTheme
import villawonka.composeapp.generated.resources.Res
import villawonka.composeapp.generated.resources.ic_heart_24

@Composable
fun AppOutlinedIconButton(
    enabled: Boolean = true,
    bordered: Boolean = true,
    iconRes: DrawableResource,
    onClick: () -> Unit,
) {
    val outlineColor = if (enabled) {
        MaterialTheme.colors.outlinedButtonThirdOutlineEnabled
    } else {
        MaterialTheme.colors.outlinedButtonThirdOutlineDisabled
    }
    val contentColor = if (enabled) {
        MaterialTheme.colors.outlinedButtonThirdContentEnabled
    } else {
        MaterialTheme.colors.outlinedButtonThirdContentDisabled
    }
    IconButton(
        onClick = onClick,
        enabled = enabled,
        modifier = Modifier
            .size(
                width = 56.dp,
                height = 48.dp
            ).let {
                if (bordered) {
                    it.border(
                        border = BorderStroke(
                            width = 1.dp,
                            color = outlineColor
                        ),
                        shape = RoundedCornerShape(12.dp)
                    )
                } else {
                    it
                }
            }
    ) {
        Icon(
            painterResource(iconRes),
            contentDescription = null,
            modifier = Modifier.size(24.dp),
            tint = contentColor
        )
    }
}

private val Colors.outlinedButtonThirdOutlineEnabled: Color
    @Composable
    get() = if (isLight) AppColors.grayLight300 else AppColors.grayDark600

private val Colors.outlinedButtonThirdOutlineDisabled: Color
    @Composable
    get() = if (isLight) AppColors.grayLight200 else AppColors.grayDark700

private val Colors.outlinedButtonThirdContentEnabled: Color
    @Composable
    get() = if (isLight) AppColors.grayLight950 else AppColors.grayDark50

private val Colors.outlinedButtonThirdContentDisabled: Color
    @Composable
    get() = if (isLight) AppColors.grayLight400 else AppColors.grayDark500

@Preview
@Composable
private fun AppOutlinedIconButtonPreview() {
    Row {
        Column(
            modifier = Modifier
                .background(Color.White)
                .padding(16.dp)
        ) {

            AppTheme(isDarkTheme = false) {

                // Enabled

                AppOutlinedIconButton(
                    iconRes = Res.drawable.ic_heart_24,
                    enabled = true
                ) {}
                AppSpacer(16.dp)

                // Disabled

                AppOutlinedIconButton(
                    iconRes = Res.drawable.ic_heart_24,
                    enabled = false
                ) {}
            }
        }
        Column(
            modifier = Modifier
                .background(Color.Black)
                .padding(16.dp)
        ) {

            AppTheme(isDarkTheme = true) {

                // Enabled

                AppOutlinedIconButton(
                    iconRes = Res.drawable.ic_heart_24,
                    enabled = true
                ) {}
                AppSpacer(16.dp)

                // Disabled

                AppOutlinedIconButton(
                    iconRes = Res.drawable.ic_heart_24,
                    enabled = false
                ) {}
            }
        }
    }
}